import BaseServices from "lib/BaseServices";
import HybridConfig from "lib/HybridConfig";
import userStore from "data/userStore";
import Dispatcher from "Dispatcher";
import SessionActions from "../data/SessionActions";
import baseServices from "../lib/BaseServices";

class SessionController extends Backbone.Controller {
    constructor(...args) {
        super(...args);
        this.initialize = this.initialize.bind(this);
        this.onUserActivity = this.onUserActivity.bind(this);
    }

    initialize() {
        this.doKeepAlive = HybridConfig.get(
            "session.keepAlive",
            true,
        );
        this.doAutoLogout = HybridConfig.get(
            "session.autoLogout",
            true,
        );
        // the length of time a session is allowed to stick around without user activity
        this.sessionTimeout = HybridConfig.get(
            "session.timeout",
            45 * 60 * 1000,
        );
        // the length of time before a session ends that the user should be prompted that it is imminent
        this.sessionTimeoutImminentDelta = HybridConfig.get(
            "session.timeoutImminentDelta",
            5 * 60 * 1000,
        );
        // how often we should check to see if the session is expired
        this.logoutCheckInterval = HybridConfig.get(
            "session.logoutCheckInterval",
            60 * 1000,
        );
        // how often we should ping the server to ensure the session is alive there
        this.keepaliveInterval = HybridConfig.get(
            "session.keepaliveInterval",
            5 * 60 * 1000,
        );
        // how often we should check to see if we should issue a keepalive
        this.keepaliveCheckInterval = HybridConfig.get(
            "session.keepaliveCheckInterval",
            30 * 1000,
        );
        // the Date of the user's last session-prolonging activity, as set via @dispatch("user:activity")
        this.lastActivity = new Date();

        // check if we need to issue a keepalive request to the server
        if (this.doKeepAlive) {
            // eslint-disable-next-line no-settimeout
            this._keepaliveInterval = setInterval(() => {
                    if (process.env.NODE_ENV !== "production" && !userStore.isRealSession()) {
                        // dev-time fake session. don't do stuff.
                        clearInterval(this._keepaliveInterval);
                        delete this._keepaliveInterval;
                        return;
                    }
                    const lastSuccess = BaseServices.getLastSuccess();
                    const age = (lastSuccess != null) ? new Date().valueOf() - lastSuccess.valueOf() : 0;
                    // console.log("ensure?", age, this.keepaliveInterval)
                    if (age > this.keepaliveInterval) {
                        // it's been long enough, send it!
                        // console.log("ensure.")
                        BaseServices.ensureSession();
                    }
                }
                , this.keepaliveCheckInterval);
        }

        // check if we should log the user out due to lack of activity
        if (this.doAutoLogout) {
            // eslint-disable-next-line no-settimeout
            this._logoutInterval = setInterval(() => {
                    if (process.env.NODE_ENV !== "production" && !userStore.isRealSession()) {
                        // dev-time fake session. don't do stuff.
                        clearInterval(this._logoutInterval);
                        delete this._logoutInterval;
                        return;
                    }
                    const age = new Date().valueOf() - this.lastActivity.valueOf();
                    // console.log("end?", age, this.sessionTimeout)
                    if (age > this.sessionTimeout) {
                        // it's been long enough, do it!
                        // alert("end.")
                        Dispatcher.dispatch({
                            type: SessionActions.timeout,
                        });
                        clearInterval(this._keepaliveInterval);
                        BaseServices.endSession();
                    } else if (age > (this.sessionTimeout - this.sessionTimeoutImminentDelta)) {
                        Dispatcher.dispatch({
                            type: SessionActions.timeoutImminent,
                            timeLeft: this.sessionTimeout - age,
                        });
                    }
                }
                , this.logoutCheckInterval);
        }
    }

    onUserActivity() {
        // console.log("onUserActivity")
        this.lastActivity = new Date();
    }

    onUserLogout() {
        baseServices.endSession();
    }
}

SessionController.prototype.events = {
    "user:activity": "onUserActivity",
    "user:logout": "onUserLogout",
};

export default SessionController;



// WEBPACK FOOTER //
// ./app/controllers/SessionController.js